// extracted by mini-css-extract-plugin
export default {"container":"PaymentMethods_container__M1ma6","preloader":"PaymentMethods_preloader__6yxE9","help":"PaymentMethods_help__KR1Ed","item":"PaymentMethods_item__xHQrg"};